/**
 * Normalizes dialog schema objects (from JS or parsed YAML).
 * YAML files under schemas/ should mirror this shape; load with js-yaml in tests/tooling.
 */
export function parseDialogSchema(raw) {
  if (!raw || typeof raw !== 'object') {
    throw new Error('Dialog schema must be an object');
  }
  const fields = Array.isArray(raw.fields) ? raw.fields : [];
  return {
    id: raw.id || 'dialog',
    titleAdd: raw.titleAdd || raw.title || 'Add',
    titleEdit: raw.titleEdit || raw.title || 'Edit',
    titleView: raw.titleView || 'Details',
    fields: fields.map(normalizeField),
  };
}

function normalizeField(field) {
  if (field.type === 'row') {
    return {
      type: 'row',
      columns: field.columns || 2,
      fields: (field.fields || []).map(normalizeField),
    };
  }
  return {
    type: field.type || 'text',
    name: field.name,
    label: field.label,
    placeholder: field.placeholder,
    required: !!field.required,
    rows: field.rows,
    options: field.options,
    when: field.when,
    slot: field.slot,
  };
}
